import React from 'react';
import { Card, CardContent, Tabs, Tab } from '@mui/material';

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { GlobalStatistics } from '../../sections/employee/statistics/GlobalStatistics';
import { DetailStatistics } from '../../sections/employee/statistics/DetailStatistics';
import { GeneralStatistics } from '../../sections/employee/statistics/GeneralStatistics';
import { useSelector } from 'react-redux';

export const Statistics = () => {
  const { module } = useSelector(state => state.app);
  const [currentTab, setCurrentTab] = React.useState(0);


  return (
    <Page title="Statystyki">
      <Card>
        <CardContent>
          <Tabs value={currentTab} onChange={(e, value) => setCurrentTab(value)}>
            <Tab label="Globalne" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/>
            { module == 'obozy' ? <Tab label="Szczegółowe" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/> : null }
            { module == 'obozy' ? <Tab label="Ogólne" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/> : null }
          </Tabs>
          {currentTab === 0
            ? <GlobalStatistics />
            : currentTab === 1
              ? <DetailStatistics />
              : currentTab === 2
                ? <GeneralStatistics />
                : null}
        </CardContent>
      </Card>
    </Page>
  );
};
